export function buildClassMenu(pathName: string, path: string) {
    if (pathName === undefined || path === undefined) {
        return '';
    }

    if (pathName === '/' && path === '/') {
        return 'is-active';
    }

    return pathName.includes(path) && path !== '/' ? 'is-active' : '';
}
